<template>
  <base-row
    v-bind="$props"
    :selectable="false"
  >
    <td>
      <Link
        v-if="hasRoute"
        :href="editAdjustmentRoute"
        class="font-semibold text-blue-600 hover:text-blue-600"
      >
        Homestead - May, 16, 2022 12:00PM
        <!-- Adjustment Name -->
      </Link>
      <a
        v-else
        @click.prevent="triggerSelected()"
        class="text-blue-600 hover:text-blue-600"
        href="#"
      >
        Homestead - May, 16, 2022 12:00PM
        <!-- Adjustment Name -->
      </a>
    </td>
    <td class="truncate max-w-xs">Damaged</td>
    <td class="truncate max-w-xs">
      May, 16, 2022
      <!-- Start -->
      <small>12:00PM</small>
    </td>
    <td>
      May, 17, 2022
      <!-- End -->
      <small>02:00PM</small>
    </td>
    <td>
      Homestead
      <!-- Location -->
    </td>
    <td>
      <div class="rounded-md text-center bg-gray-200 text-blue-600 py-1 px-2 text-sm">Started</div>
      <!-- Status -->
    </td>
  </base-row>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import TableRow from '@/Components/Table/TableRow'
import RowProps from '@/Components/Table/Mixins/RowProps'
import BasicBadge from '@/Components/Badges/BasicBadge.vue'
import _date from '@/Filters/Date'
import _dollars from '@/Filters/Dollars'
import _time from '@/Filters/Time'
import moment from 'moment'

export default {
  components: {
    'base-row': TableRow,
    Link,
    BasicBadge
  },

  mixins: [RowProps],

  props: {
    /**
     * A function that we can use to generate the URL to view a item. Returns a string that is a valid URL
     */
    showRoute: {
      type: Function,
      default: (item) => null
    },

    defaultLocationName: {
      type: String,
      default: 'Default Store'
    }
  },

  computed: {
    /**
     * Returns the URL we can use to view a customer
     */
    editTransferRoute() {
      return this.showRoute(this.item)
    },

    /**
     * Returns true if this customer has a valid URL to view a customer
     * @returns {boolean}
     */
    hasRoute() {
      return this.editTransferRoute !== null
    },

    statusDate() {
      if (this.item.display_status === 'Received') {
        return this.item.received_at
      }

      if (this.item.display_status === 'In Transit') {
        return this.item.sent_at
      }

      return null
    }
  },
  methods: {
    _date,
    _dollars,
    _time,
    formatDate(value) {
      return moment(String(value)).format('MM/DD/YYYY')
    },
    triggerSelected() {
      this.$emit('selected', this.item)
    }
  }
}
</script>
